import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Collapse, ConfigProvider } from 'antd';
import { openAuth } from '../../features/ui/actions';
import loyaltyBanner from '../../icons/loylty-program.jpeg';
import './styles.css';

const faqItems = [
    {
        key: '1',
        label: 'Как зарегистрироваться?',
        children: (
            <div>
                <p>Два простых способа:</p>
                <p>
                    1. Через сайт – зарегистрируйтесь на сайте, заполнив короткую форму.
                    Вы получаете доступ к Личному кабинету на сайте е-фид. Пароль для входа в Личный кабинет
                    придёт по электронной почте или в SMS уведомлении.
                </p>
                <p>
                    2. При первом заказе – поставьте галочку «Создать учетную запись» на странице оформления.
                    Учетная запись создастся автоматически, а бонусы за покупку сразу поступят на ваш счет.
                </p>
                <p><strong>Важно:</strong></p>
                <ul>
                    <li>Учетная запись имеет свой уникальный бонусный счет, привязанный к ней.</li>
                    <li>Одна учетная запись может иметь только один бонусный счет.</li>
                </ul>
            </div>
        ),
    },
    {
        key: '2',
        label: 'Как проверить баланс и использовать бонусы?',
        children: (
            <div>
                <p>
                    1. <strong>Войдите</strong> в Личный кабинет.
                    Пароль для входа в Личный кабинет вы получите по электронной почте или в SMS уведомлении.
                </p>
                <p>
                    2. <strong>Посмотрите</strong> баланс в Личном кабинете (раздел «Состояние бонусного счета»).
                </p>
                <p>
                    3. При оформлении заказа, нажмите кнопку «Списать бонусы» с вашего бонусного счет. Списание
                    бонусов происходит автоматически, уменьшая стоимость продукции для оплаты.
                </p>
                <p><strong>Важно:</strong></p>
                <ul>
                    <li>Бонусы становятся доступны через 7 дней после получения заказа.</li>
                    <li>Использовать бонусы можно уже после первой покупки – достаточно зарегистрироваться на сайте.</li>
                    <li>Оплата доставки бонусами не допускается.</li>
                    <li>На товары по акции бонусы использовать нельзя.</li>
                </ul>
            </div>
        ),
    },
    {
        key: '3',
        label: 'Срок действия бонусов',
        children: (
            <div>
                <ul>
                    <li>Обычные бонусы действуют 180 дней. Не использованные – сгорают.</li>
                    <li>Аукционные бонусы – если бонусы были начислены в рамках акции, срок их действия указывается отдельно в правилах данной акции. (Пример: бонусы за отзыв сгорают через 30 дней)</li>
                </ul>
            </div>
        ),
    },
    {
        key: '4',
        label: 'Как копить бонусы?',
        children: (
            <div>
                <p>
                    Чтобы накапливать бонусы, просто оставайтесь зарегистрированными при каждой покупке в интернет-магазине.
                    Бонусы начисляются за каждый рубль. Чем чаще и больше Вы покупаете, тем больше бонусов на счете
                </p>
            </div>
        ),
    },
];

const LoyaltyProgram = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <ConfigProvider
            theme={{
                token: { colorPrimary: '#D00202' },
                components: {
                    Button: { colorPrimaryHover: '#ff3333' },
                    Collapse: {
                        headerBg: 'rgba(255, 255, 255, 0.05)',
                        contentBg: 'transparent',
                        colorText: 'rgba(255, 255, 255, 0.7)',
                        colorTextHeading: '#fff',
                        colorBorder: 'rgba(255, 255, 255, 0.1)',
                    },
                },
            }}
        >
            <div className="loyalty-page">
                <div className="loyalty-container">
                    <h1 className="loyalty-title">Честная программа лояльности e-feed!</h1>
                    <p className="loyalty-subtitle">
                        Получайте бонусы e-feed и оплачивайте ими до 50% от ваших заказов.
                    </p>

                    <div className="loyalty-banner">
                        <img src={loyaltyBanner} alt="Программа лояльности e-feed" />
                    </div>

                    <div className="loyalty-buttons">
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => dispatch(openAuth())}
                        >
                            Стать участником
                        </Button>
                        {/* <Button
                            size="large"
                            onClick={() => navigate('/profile')}
                            style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}
                        >
                            Проверить баланс в Личном кабинете
                        </Button> */}
                    </div>

                    <section className="loyalty-section">
                        <h2>Как это работает?</h2>
                        <p>
                            Вы оформляете покупку — мы начисляем 2% бонусами от ее стоимости (не распространяется на доставку).
                        </p>
                        <p>
                            1 бонус = 1 рубль. Никаких дробей и скрытых условий.
                        </p>
                        <p>
                            Накопленные бонусы можно тратить на следующие заказы и закрывать ими до 50% стоимости нового заказа.
                            Чем больше покупаете, тем больше экономите!
                        </p>
                        <p>
                            Наша прозрачность! Мы начисляем бонусы даже на ту оплату, в которой вы совершаете списание
                            предыдущих бонусов!
                        </p>
                    </section>

                    <section className="loyalty-section">
                        <h2>Пример:</h2>
                        <div className="loyalty-example">
                            <p>
                                <strong>Вы:</strong> Купили продукцию CattlePro (или любую другую) на сумму: 80 000 руб.
                            </p>
                            <p>
                                <strong>Мы:</strong> Начисляем вам на карту лояльности: 80 000 руб. Х 2% = 1 600 бонусов.
                            </p>
                            <p>
                                Следующую покупку вы может оплатить бонусами или копить их дальше. Не забывайте авторизоваться
                                в учетной записи e-feed.ru перед покупкой!
                            </p>
                            <p>
                                <strong>Вы:</strong> Делаете 2-ю покупку продукции Dr. John на сумму: 60 000 руб. и при этом
                                используете свою скидку 1 600 бонусов.
                            </p>
                            <p>
                                <strong>Итого к оплате:</strong> 58 400 руб. (доставка оплачивается отдельно).
                            </p>
                            <p>
                                <strong>Мы:</strong> Снова начислим на вашу карту лояльности: 58 400 руб. Х 2% = 1 168 бонусов
                            </p>
                        </div>
                        <p>Все просто!</p>
                    </section>

                    <section className="loyalty-section">
                        <h2>Часто задаваемые вопросы</h2>
                        <Collapse
                            items={faqItems}
                            bordered={false}
                            expandIconPosition="start"
                            className="loyalty-faq"
                        />
                    </section>

                    <section className="loyalty-section">
                        <h2>Условия программы лояльности:</h2>
                        <ul>
                            <li>2% от суммы оплаченной продукции возвращается бонусами.</li>
                            <li>Бонусы не начисляются при покупках на Распределительных Центрах e-Feed.</li>
                            <li>Данная версия Правил вступила в силу с 14.10.2021 г.</li>
                        </ul>
                    </section>

                    <section className="loyalty-section">
                        <h2>Возврат бонусов при отмене заказа</h2>
                        <ul>
                            <li>Если заказ был отменен до получения или продавец не подтвердил заказ – бонусы вернутся на ваш счет в полном объеме в течение 48 часов.</li>
                            <li>В случае частичного отказа от товара в заказе или полного отказа от уже доставленного товара – бонусы восстанавливаются в течение 30 календарных дней.</li>
                        </ul>
                    </section>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default LoyaltyProgram;
